import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedRoleAutocomplete, FormRolesSpecialtiesSelector } from 'shared/components';
import { useFeatureEnabled } from 'shared/hooks';

import { CandidateProfileFormData } from '../../../types';
import LargerInputContainer from './LargerInputContainer';

export default function FieldRolesSpecialties() {
    const { control } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');
    const isRoleSpecialtyEnabled = useFeatureEnabled('RoleSpecialtyTaxonomy');

    if (!isRoleSpecialtyEnabled) {
        return (
            <LargerInputContainer>
                <ConnectedRoleAutocomplete
                    control={ control }
                    name="roles"
                    multiple
                />
            </LargerInputContainer>
        );
    }

    return (
        <LargerInputContainer>
            <FormRolesSpecialtiesSelector
                control={ control }
                name="roleSpecialties"
                label={ t('fields.rolesSpecialties') }
            />
        </LargerInputContainer>
    );
}
